<template>
  <div class="Gift-Card-Index">
    <div :style="indexStyle">
      <img style="width: 100%;" :src="bgSrc" alt="" />
      <div class="Gift-Card-Index-BOTTOM-Text">
        <p>本次活动已结束，谢谢！</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'duan-wu-stop', // 活动结束封面
  data () {
    return {
      bgSrc: require('@/assets/gift-card-index.png'),
      indexStyle: { height: '100%', overflow: 'hidden' }
    }
  },
  computed: {},
  methods: {},
}
</script>

<style lang="less">
.Gift-Card-Index {
  position: relative;
  height: 100%;
  overflow: auto;

  .invitationLetterIndexBtnGroup {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Gift-Card-Index-BOTTOM-Text {
    position: fixed;
    bottom: 16px;
    left: 0;
    text-align: center;
    width: 100%;

    p {
      color: #000;
      font-size: 18px;
      font-weight: bold;
      line-height: 1.8em;
      margin: 0;
    }
  }
}
</style>
